import { render, staticRenderFns } from "./ValueBox.vue?vue&type=template&id=0ba2f517&"
import script from "./ValueBox.vue?vue&type=script&lang=js&"
export * from "./ValueBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports